import { dayjs } from './localizedDayjs';

export const formatDate = (date: dayjs.ConfigType, format: string): string => {
  return dayjs(date).format(format);
};
